'use strict';

/**
 * BD.OpenStreetMap: Embeds OSM on product pages.
 */
var BD = window.BD = window.BD || {};

BD.OpenStreetMap = (function($) {
  var map;

  // Openmaps defaults to long/lat coordinates (https://openlayers.org/en/latest/doc/faq.html#why-is-the-order-of-a-coordinate-lon-lat-and-not-lat-lon-)
  // This function uses the more intuitive latitude/longitude transformation
  function pointFromLatLon(coords) {
    if (arguments.length == 2) { coords = arguments; }
    return ol.proj.fromLonLat([ parseFloat(coords[1]), parseFloat(coords[0]) ]);
  }
  
  function init() {
    var mapElementId = 'map_canvas';
    var $map = $('#' + mapElementId).closest('.map-ui');
    
    if (!document.getElementById(mapElementId)) { return; }
    
    var mapCenter = [ 45.423283,-75.697609 ]; 
    var mapCenterPoint = pointFromLatLon(mapCenter);
    
    var markerPoints = (!BD.mapMarkers) ? [] : BD.mapMarkers.map((marker, idx) => {
      if (!marker.lat || !marker.long) { return null }
          
      var point = pointFromLatLon(marker.lat, marker.long);
      point.markerNum = idx + 1;
      point.name = marker.title;
      return point;
    })
    .filter((point) => point != null);
    
    var mapOptions = {
      layers: [ 
        //new ol.layer.Tile({ source: new ol.source.OSM() })
        //new ol.layer.Tile({ source: new ol.source.Stamen({ layer: "terrain" }) })
        new ol.layer.Tile({ source: new ol.source.Stamen({ layer: "toner-lite" }) })
        //new ol.layer.Tile({ source: new ol.source.Stamen({ layer: "toner" }) })
      ],
      target: mapElementId,
      view: new ol.View({
        center: mapCenterPoint,
        zoom: 16
      }),
    };

    map = new ol.Map(mapOptions);

    if (markerPoints.length) {
      var ext = ol.extent.boundingExtent(markerPoints);
      map.getView().fit(ext, map.getSize());
    }

    markerPoints.forEach((point) => {
      var markerEl = $('<div class="mapMarker"></div>').text(point.markerNum)[0];
      $map.append(markerEl);
      
      var overlay = new ol.Overlay({ element: markerEl });
      map.addOverlay(overlay);
      overlay.setPosition(point);
    });
  }
  
  $(init);
  
  return {
    getMap: () => map
  }
})(jQuery);
